import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, DescriptiveText, Dropdown, LoadingSpinner, Page, Tile} from '../../../shared';
import axiosInstance from '../../../shared/utils/axios';
import {open} from '../../../shared/utils/utils';
import {_openModal} from '../../../shared/reducers/modals';
import qs from 'query-string';
import useSWR from 'swr';

/**
 * Launches MGP given a household
 * @param householdID
 * @param openModal
 * @return {Promise}
 */
export const mgpLaunch = (householdID, openModal) => axiosInstance.get(`/auth/mgp/login?householdId=${householdID}`)
  .then(res => open('POST', res.data.postUrl, {RelayState: res.data.RelayState, SAMLResponse: res.data.SAMLResponse}, '_blank'))
  .catch(err => openModal({type: 'Error', title: 'MoneyGuide Error', err}));

const Mgp = ({openModal}) => {
  const [householdID, setSelectedHousehold] = useState(null);
  const {data: households} = useSWR(`/households?${qs.stringify({sort: '+name', asAdvisor: 1})}`);
  const options = React.useMemo(() => !!households && households.map(row => ({label: row.name, value: row.id})), [households]);

  const updateSelectedHousehold = (name, option) => {
    setSelectedHousehold(option.value);
  };

  return <Page center={true}>
    <Tile key='MoneyGuide' title='MoneyGuide' width={'fit-content'}>
      {!options && <LoadingSpinner/>}
      {!!options && <>
        <DescriptiveText>
          Select a household from the drop down menu and click continue.
        </DescriptiveText>
        <DescriptiveText>
          Please note that MoneyGuide will open on a new tab so make sure your popup blocker is set to allow the link to be opened.
        </DescriptiveText>
        <Dropdown dataPoint={{name: 'household'}}
                  placeholder='Select a Household'
                  isSearchable={true}
                  onChange={(name, option) => updateSelectedHousehold(name, option)}
                  options={options}
                  width={'fill'}/>
        <Button importance={'primary'}
                size={'md'}
                label={'Continue'}
                disabled={false}
                action={() => mgpLaunch(householdID, openModal)}/>
      </>}
    </Tile>
  </Page>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(null, mapDispatchToProps)(Mgp);

Mgp.propTypes = {
  openModal: PropTypes.func.isRequired,
  session: PropTypes.object,
};
